// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.customer-portal-login {
    box-shadow: 1px 1px 13px 0 #10101036;
    line-height: 0;
}

.customer-portal-login .slick-slide {
    padding: 0;
    position: relative;
}

.customer-portal-login .slick-slider {
    background-color: #988C67;
}

.customer-portal-login .login-slide {
    width: 150px;
    min-height: 410px;
    /*don'd forget space for error message */
    background-color: #988C67;
}

.customer-portal-login .line-height-1-3 {
    line-height: 1.3em;
}

.customer-portal-login .login-slide-container {
    padding: 10px 15px;
    text-align: center;
}

.customer-portal-login .login-slide-container:first-child {
    padding-top: 30px;
}

.customer-portal-login .login-slide-container:last-child {
    padding-bottom: 30px;
    min-height: 80px;
}

.customer-portal-login .login-slide h2 {
    margin: 5px 15px 20px;
    font-size: 25px;
    padding: 0;
}

.customer-portal-login h2, .customer-portal-login p {
    color: white;
    margin: 5px;
    text-align: center;
    font-size: .9em;
}

.customer-portal-login .customer-portal-header {
    text-align: center;
    padding: 30px;
}

.customer-portal-login .customer-portal-footer {
    text-align: center;
    padding: 5px;
    color: black;
}

.customer-portal-login .customer-portal-footer a {
    color: #988C67;
}

.customer-portal-login .customer-portal-newsletter {
    text-align: center;
    padding-bottom: 45px;
}

.customer-portal-login .customer-portal-footer p {
    color: black;
    font-size: .5em;
}

.customer-portal-login .customer-portal-newsletter p {
    font-size: .5em;
}

.customer-portal-login.invest .customer-portal-header img {
    display: inline-block;
    width: 172px;
}

#top .customer-portal-login input[type=email], #top .customer-portal-login input[type=email]:focus,
#top .customer-portal-login input[type=password], #top .customer-portal-login input[type=password]:focus {
    background-color: transparent;
    border: 0;
    border-bottom: 2px solid white;
    color: white;
    font-weight: bold;
    outline: none;
}

#top .customer-portal-login input[type=email]:read-only {
    background-color: #7e7460 !important;
}

#top .customer-portal-login input::placeholder {
    color: white !important;
    font-weight: normal;
}


.customer-portal-login button {
    padding: 10px;
    line-height: 20px;
    width: 100%;
    font-size: 18px;
}

.customer-portal-login button.login {
    border: 2px solid;
}

.customer-portal-login .password-forget {
    background-color: transparent;
    color: white;
    float: right;
}

.customer-portal-login .to-bottom {
    bottom: 20px;
    position: absolute;
    left: 20px;
    right: 20px;
}

.customer-portal-login .width-50 {
    width: 50%;
}

.customer-portal-login .submit {
    background-color: transparent;
    color: white;
    float: left;
}

.customer-portal-login button:hover {
    color: #dddddd;
    border-color: #dddddd;
}

.customer-portal-login button:disabled {
    opacity: .6;
}

.customer-portal-login img.start-video {
    width: 100%;
}

.customer-portal-login img.ok {
    display: inline-block;
}

.customer-portal-login a {
    color: white;
    cursor: pointer;
}

.customer-portal-login a.small {
    font-size: .9em;
}

.customer-portal-login a:hover {
    color: #dddddd;
}

.customer-portal-login a {
    color: white;
    line-height: 1.3em;
}

#top .customer-portal-login label {
    color: white;
    font-family: franklingothic-book, Helvetica, Arial, sans-serif;
}

#top .customer-portal-login label a {
    text-decoration: underline;
    font-family: franklingothic-book, Helvetica, Arial, sans-serif;
}

.customer-portal-login .error_message {
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/customer-portal-login.css"],"names":[],"mappings":";AACA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;IAC7B,SAAS;IACT,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,8DAA8D;AAClE;;AAEA;IACI,0BAA0B;IAC1B,8DAA8D;AAClE;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.customer-portal-login {\n    box-shadow: 1px 1px 13px 0 #10101036;\n    line-height: 0;\n}\n\n.customer-portal-login .slick-slide {\n    padding: 0;\n    position: relative;\n}\n\n.customer-portal-login .slick-slider {\n    background-color: #988C67;\n}\n\n.customer-portal-login .login-slide {\n    width: 150px;\n    min-height: 410px;\n    /*don'd forget space for error message */\n    background-color: #988C67;\n}\n\n.customer-portal-login .line-height-1-3 {\n    line-height: 1.3em;\n}\n\n.customer-portal-login .login-slide-container {\n    padding: 10px 15px;\n    text-align: center;\n}\n\n.customer-portal-login .login-slide-container:first-child {\n    padding-top: 30px;\n}\n\n.customer-portal-login .login-slide-container:last-child {\n    padding-bottom: 30px;\n    min-height: 80px;\n}\n\n.customer-portal-login .login-slide h2 {\n    margin: 5px 15px 20px;\n    font-size: 25px;\n    padding: 0;\n}\n\n.customer-portal-login h2, .customer-portal-login p {\n    color: white;\n    margin: 5px;\n    text-align: center;\n    font-size: .9em;\n}\n\n.customer-portal-login .customer-portal-header {\n    text-align: center;\n    padding: 30px;\n}\n\n.customer-portal-login .customer-portal-footer {\n    text-align: center;\n    padding: 5px;\n    color: black;\n}\n\n.customer-portal-login .customer-portal-footer a {\n    color: #988C67;\n}\n\n.customer-portal-login .customer-portal-newsletter {\n    text-align: center;\n    padding-bottom: 45px;\n}\n\n.customer-portal-login .customer-portal-footer p {\n    color: black;\n    font-size: .5em;\n}\n\n.customer-portal-login .customer-portal-newsletter p {\n    font-size: .5em;\n}\n\n.customer-portal-login.invest .customer-portal-header img {\n    display: inline-block;\n    width: 172px;\n}\n\n#top .customer-portal-login input[type=email], #top .customer-portal-login input[type=email]:focus,\n#top .customer-portal-login input[type=password], #top .customer-portal-login input[type=password]:focus {\n    background-color: transparent;\n    border: 0;\n    border-bottom: 2px solid white;\n    color: white;\n    font-weight: bold;\n    outline: none;\n}\n\n#top .customer-portal-login input[type=email]:read-only {\n    background-color: #7e7460 !important;\n}\n\n#top .customer-portal-login input::placeholder {\n    color: white !important;\n    font-weight: normal;\n}\n\n\n.customer-portal-login button {\n    padding: 10px;\n    line-height: 20px;\n    width: 100%;\n    font-size: 18px;\n}\n\n.customer-portal-login button.login {\n    border: 2px solid;\n}\n\n.customer-portal-login .password-forget {\n    background-color: transparent;\n    color: white;\n    float: right;\n}\n\n.customer-portal-login .to-bottom {\n    bottom: 20px;\n    position: absolute;\n    left: 20px;\n    right: 20px;\n}\n\n.customer-portal-login .width-50 {\n    width: 50%;\n}\n\n.customer-portal-login .submit {\n    background-color: transparent;\n    color: white;\n    float: left;\n}\n\n.customer-portal-login button:hover {\n    color: #dddddd;\n    border-color: #dddddd;\n}\n\n.customer-portal-login button:disabled {\n    opacity: .6;\n}\n\n.customer-portal-login img.start-video {\n    width: 100%;\n}\n\n.customer-portal-login img.ok {\n    display: inline-block;\n}\n\n.customer-portal-login a {\n    color: white;\n    cursor: pointer;\n}\n\n.customer-portal-login a.small {\n    font-size: .9em;\n}\n\n.customer-portal-login a:hover {\n    color: #dddddd;\n}\n\n.customer-portal-login a {\n    color: white;\n    line-height: 1.3em;\n}\n\n#top .customer-portal-login label {\n    color: white;\n    font-family: franklingothic-book, Helvetica, Arial, sans-serif;\n}\n\n#top .customer-portal-login label a {\n    text-decoration: underline;\n    font-family: franklingothic-book, Helvetica, Arial, sans-serif;\n}\n\n.customer-portal-login .error_message {\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
